/**
 * hedgeDetector — WRAPPER-DISCIPLINE-EXT-1
 *
 * Pure function. Scans text for forbidden hedge phrases.
 * Used as a pre-gate filter when context.isDeclarative === true.
 * Match triggers abstention with reason='forbidden_hedge_in_declarative'.
 */

/**
 * @param {string} text - rawOutput to scan
 * @param {string[]} hedgeList - resolved hedge list (from forbiddenHedges.resolveHedgeList)
 * @returns {{ hedgeDetected: boolean, matchedPhrases: string[] }}
 */
export function detectHedge(text, hedgeList) {
  if (!text || !Array.isArray(hedgeList) || hedgeList.length === 0) {
    return { hedgeDetected: false, matchedPhrases: [] };
  }

  const lower = text.toLowerCase();
  const matchedPhrases = hedgeList.filter(phrase => lower.includes(phrase.toLowerCase()));

  return {
    hedgeDetected: matchedPhrases.length > 0,
    matchedPhrases,
  };
}
